var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsFullPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "f79384c8-427c-4563-8da1-4fd9c9e82d44"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(30,0,57)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "aa6c5cfe-7db5-4732-95c8-1dab197c134c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.31 0 0 1.31 543.07 446.72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(30,0,57)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-350.28, -280.28)",
    d: "M 600.88 228.48 L 541.521 218.398 C 538.1615999999999 207.757 533.6812 197.679 528.6419999999999 187.597 L 563.361 138.87800000000001 C 568.4001 131.5968 567.8415 121.519 561.6813 115.35800000000002 L 514.0793 67.75600000000003 C 507.9191 61.595800000000025 497.8413 60.47480000000003 490.5593 66.07630000000003 L 441.8403 100.79530000000003 C 432.3208 95.75620000000002 421.6803 91.27580000000003 411.0393 87.91630000000002 L 401.51980000000003 29.119300000000024 C 399.8401 20.15840000000002 392.55890000000005 13.998300000000024 383.5978 13.998300000000024 L 316.3988 13.998300000000024 C 307.4379 13.998300000000024 300.1608 20.158500000000025 298.47679999999997 29.119300000000024 L 288.3988 88.47830000000002 C 277.7578 91.83770000000001 267.6798 96.31810000000002 257.5978 101.35730000000002 L 208.8788 66.63830000000002 C 201.5976 61.59920000000002 191.5198 62.157800000000016 185.3588 68.31800000000001 L 137.7568 115.92000000000002 C 131.5966 122.08020000000002 130.4756 132.15800000000002 136.0771 139.44000000000003 L 170.7961 188.15900000000002 C 165.757 197.6785 161.2766 208.31900000000002 157.9171 218.96 L 99.12010000000001 228.4795 C 90.15920000000001 230.1592 83.99910000000001 237.4404 83.99910000000001 246.4015 L 83.99910000000001 313.6005 C 83.99910000000001 322.5614 90.15930000000002 329.8385 99.12010000000001 331.52250000000004 L 158.47910000000002 341.6005 C 161.8385 352.24150000000003 166.3189 362.3195 171.3581 372.4015 L 136.6391 421.1205 C 131.60000000000002 428.4017 132.1586 438.4795 138.3188 444.6405 L 185.9208 492.24249999999995 C 192.08100000000002 498.4026999999999 202.1588 499.52369999999996 209.44080000000002 493.9222 L 258.1598 459.2032 C 267.6793 464.2423 278.31980000000004 468.7227 288.9608 472.0822 L 299.0388 531.4412 C 300.7185 540.4021 307.99969999999996 546.5622 316.9608 546.5622 L 384.1598 546.5622 C 393.1207 546.5622 400.3978 540.4019999999999 402.08180000000004 531.4412 L 411.60130000000004 471.51919999999996 C 422.24230000000006 468.15979999999996 432.32030000000003 463.67939999999993 442.4023 458.64019999999994 L 491.1213 493.35919999999993 C 498.40250000000003 498.39829999999995 508.4803 497.83969999999994 514.6413 491.6794999999999 L 562.2433 444.07749999999993 C 568.4035 437.91729999999995 569.5245 427.83949999999993 563.923 420.55749999999995 L 529.204 371.83849999999995 C 534.2430999999999 362.31899999999996 538.7235 351.67849999999993 542.083 341.03749999999997 L 601.442 330.9595 C 610.4029 329.27979999999997 616.563 321.9986 616.563 313.03749999999997 L 616.559094 246.39649999999995 C 616.000504 237.43949999999995 609.840294 230.15849999999995 600.879094 228.47849999999994 z M 350 375.76 C 296.801 375.76 254.238 332.639 254.238 279.998 C 254.238 226.79899999999998 297.359 184.236 350 184.236 C 402.641 184.236 445.762 226.798 445.762 279.998 C 445.762 333.198 403.2 375.76 350 375.76 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFullPurple);
export default __webpack_public_path__ + "static/media/Settings-full-purple.ed8629c0aca1d4bf3ea7c9f172e8e33f.svg";
export { ForwardRef as ReactComponent };